var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.watermarkText)?_c('div',{staticClass:"user-watermark",style:(_vm.watermarkStyle)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }